import { render } from "./ChatWith.vue?vue&type=template&id=2c365c74&scoped=true"
import script from "./ChatWith.vue?vue&type=script&lang=js"
export * from "./ChatWith.vue?vue&type=script&lang=js"

import "./ChatWith.vue?vue&type=style&index=0&id=2c365c74&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c365c74"]])

export default __exports__